import { getCurrencySymbol } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CurrencyService } from 'src/app/services/currency.service';
import { NoteService } from 'src/app/services/note.service';
import { BrowserStorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-note-list',
  templateUrl: './note-list.component.html',
  styleUrls: ['./note-list.component.scss']
})


export class NoteListComponent implements OnInit {
  @Input() userId;
  public notes = [];
  public isLoading: boolean;
  private currencySubscription: Subscription;
  public selectedCurrency: string;
  public currencySymbol: string;
  max = 0;
  frame = {
    userId: null,
    sortBy: 'date'
  }
  constructor(
    private noteService: NoteService,
    private currencyService: CurrencyService,
    private browserStorageService: BrowserStorageService
  ) { }

  ngOnInit(): void {
    this.frame = {
      userId: this.userId,
      sortBy: 'date'
    }
    this.getCurrency();
    this.currencySubscription = this.currencyService.
      currencyChangeEmitter.subscribe((name: string) => {
        this.getCurrency();
      });
    this.getMyNotes();
  }

  public getCurrency() {
    setTimeout(() => {
      this.selectedCurrency = this.browserStorageService.get("_currency");
      this.currencySymbol = getCurrencySymbol(this.selectedCurrency, "narrow");
    }, 100);
  }

  public sortBy(sort) {
    this.frame.sortBy = sort;
    this.getMyNotes();
  }

  private getMyNotes() {
    this.isLoading = true;
    return this.noteService.myNotes(this.frame).subscribe(data => {
      this.notes = data.data;
      this.max = data.message;
      this.isLoading = false;
    });
  }

}
